import { Section } from "@nexcloud/nc-ui";

const HistoryTab = () => {
  return <Section>HistoryTab</Section>;
};

export default HistoryTab;
